import { render } from "./MastHeadSectionComponent.vue?vue&type=template&id=d71aff20&ts=true"
import script from "./MastHeadSectionComponent.vue?vue&type=script&lang=ts"
export * from "./MastHeadSectionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__